(function () {
    function updateCartAttribute(distinctId) {
        fetch('/cart/update.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                attributes: {
                    '_posthog_distinct_id': distinctId
                }
            })
        }).then(response => {
            if (response.ok) {
                console.log('PostHog Distinct ID saved to cart');
                // Save to sessionStorage to avoid repeated calls
                sessionStorage.setItem('ph_cart_synced', distinctId);
            }
        }).catch(console.error);
    }

    function initBridge() {
        if (window.posthog) {
            function trySync() {
                if (!posthog.get_distinct_id) return;
                var distinctId = posthog.get_distinct_id();
                var syncedId = sessionStorage.getItem('ph_cart_synced');

                if (distinctId && distinctId !== syncedId) {
                    updateCartAttribute(distinctId);
                }
            }

            // Sync ASAP after PostHog loads.
            trySync();

            // Also retry after feature flags load (if enabled) to catch late init.
            if (posthog.onFeatureFlags) {
                posthog.onFeatureFlags(trySync);
            }
        }
    }

    // Poll for PostHog
    var checks = 0;
    var interval = setInterval(function () {
        if (window.posthog) {
            clearInterval(interval);
            initBridge();
        }
        checks++;
        if (checks > 50) clearInterval(interval); // Stop after 5s
    }, 100);
})();
